import React from "react";
import PriceTab from "../../../common/PriceTab";

const ItalyComoPriceTab = () => {
    return (
        <PriceTab
            content={{
                includes: 'italy_como_price_included',
                notIncludes: 'italy_como_price_not_included',
                price: 'italy_como_price',
            }}
        />
    );
}

export default ItalyComoPriceTab;
